import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BrokerList } from 'src/app/shared/models/broker-list';
import { Equipe } from 'src/app/shared/models/team-member';
import { CorretorService } from 'src/app/shared/services/corretor.service';
import { PaginaService } from 'src/app/shared/services/pagina.service';
import { SeoService } from 'src/app/shared/util/seo.service';
import { SessionManager } from 'src/app/shared/util/session-manager';
import { formatPhone, PAGE_TITLE } from 'src/globals';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent implements OnInit {
  title = 'Institucional';
  formatPhone = formatPhone;
  brokers$: Observable<BrokerList>;
  team$: Observable<Equipe[]>;

  constructor(
    private titleService: Title,
    private corretorService: CorretorService,
    private pageService: PaginaService,
    private seo: SeoService
  ) {
    this.titleService.setTitle(`${this.title} - ${PAGE_TITLE}`);
  }

  ngOnInit(): void {
    this.loadData();
    this.updateSEO();
  }

  loadData() {
    this.brokers$ = this.corretorService.getCorretores().pipe(
      catchError(error => {
        SessionManager.handleHttpError(error, 'Não foi possível consultar corretores');
        return of(null);
      })
    );

    this.team$ = this.pageService.getEquipe().pipe(
      catchError(error => {
        SessionManager.handleHttpError(error, 'Não foi possível consultar a equipe');
        return of(null);
      })
    );
  }

  updateSEO() {
    // title
    let title = `${this.title} - ${PAGE_TITLE}`;
    this.titleService.setTitle(title);

    // Adiciona/Atualiza as Tags ao head da pagina
    this.seo
      .addTitle(title)
      .addDescription(
        'Saiba mais sobre nós, nossos valores e os nossos principais objetivos! Venda e locação de imóveis de alto padrão é na Private Imóveis.'
      );
  }
}
